module.exports = __webpack_public_path__ + "static/img/icon_trns_bus.fea4f55.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/common/icon_trns_bus.svg
// module id = 3wS9
// module chunks = 10